import { CreateMitarbeiterMutation } from '@/gql/graphql';

// oxlint-disable-next-line complexity
export function getWarningSearchParams(
  result: CreateMitarbeiterMutation['mitarbeiter_mitarbeiterCreate']['success'],
): string {
  if (!result) return '';
  const params = new URLSearchParams();

  if (result.fristenResult?.result?.some((r) => !!r.failure)) {
    params.set('FristenWarning', 'true');
  }
  if (result.personalzugang?.error) {
    params.set('PersonalzugangWarning', 'true');
  }
  return params.toString();
}
